module.exports = __webpack_public_path__ + "media/staff/Betty-and-Dana-778c79f8.jpg";